"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Masthead = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Masthead = function Masthead(props) {
  var _a;
  var children = props.children,
    className = props.className;
  var customProps = _1.omit(props, Object.keys(exports.Masthead.propTypes));
  var rootClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('masthead')] = true, _a);
  return react_1.default.createElement("div", __assign({}, customProps, {
    className: classnames_1.classNames(className, rootClasses)
  }), children);
};
exports.Masthead = Masthead;
exports.Masthead.propTypes = {
  children: prop_types_1.default.node,
  className: prop_types_1.default.string
};
exports.Masthead.displayName = 'Masthead';